<template>
    <vx-card
        title="Lista produktów"
        title-color="primary"
        subtitle="Dodane przez Ciebie produkty" :buttons="page.buttons">

        <vs-popup class="holamundo" title="Wydruk etykiety" :active.sync="popupActive">
            <div class="w-full">
                <vs-radio v-model="params.weight" vs-value="weight:100">Wartości odżywcze dla 100 g produktu</vs-radio>
                <vs-radio v-model="params.weight" vs-value="weight:single">Wartości odżywcze dla jednego produktu
                </vs-radio>
                <vs-radio v-model="params.weight" vs-value="weight:full">Wartości odżywcze dla całej receptury
                </vs-radio>
                <vs-divider></vs-divider>
                <div class="vx-row px-2 mt-4">
                    <div class="flex w-full">
                        <div class="w-1/2">
                            <vs-checkbox v-model="params.main" disabled="true">Wartości odżywcze, nazwa, waga
                            </vs-checkbox>
                            <vs-checkbox v-model="params.contains">Może zawierć</vs-checkbox>
                            <vs-checkbox v-model="params.keep">Warunki przechowywania</vs-checkbox>
                            <vs-checkbox v-model="params.best_before">Należy spożyć</vs-checkbox>
                            <vs-checkbox v-model="params.producer">Producent</vs-checkbox>
                            <vs-checkbox v-model="params.gda">RWS</vs-checkbox>
                            <vs-checkbox v-model="params.recipe">Notatki</vs-checkbox>
                            <vs-checkbox v-model="params.one_line">Tekst jednowierszowy</vs-checkbox>
                        </div>
                        <div class="w-1/2">
                            <vs-checkbox v-model="params.show_fiber_additional">Pokaż błonnik</vs-checkbox>
                            <!--<vs-checkbox v-model="params.roughage">Błonnik</vs-checkbox>-->
                            <vs-checkbox v-model="params.ean_8">Kod kreskowy EAN 8</vs-checkbox>
                            <vs-checkbox v-model="params.ean_13">Kod kreskowy EAN 13</vs-checkbox>
                            <vs-checkbox v-model="params.wni">WNI</vs-checkbox>
                            <vs-checkbox v-model="params.products">Lista składników</vs-checkbox>
                            <vs-checkbox v-model="params.percent">Zawartość procentowa</vs-checkbox>
                            <vs-checkbox v-model="params.price">Cena</vs-checkbox>
                            <vs-checkbox v-model="params.logo">Logo firmy</vs-checkbox>
                        </div>
                    </div>
                </div>
                <vs-divider></vs-divider>
                <div class="vx-row px-2 mt-4">
                  <div class="flex w-full">
                    <div class="w-1/4 mr-2">
                      <label>Wielkość fontu - Nazwa</label>
                      <select v-model="params.font_size_name"
                              class="flex-1 w-4/5 vs-inputx vs-input--input">
                        <option v-for="(item, key) in font_sizes" :value="item.value" class="w-4/5">
                          {{ item.text }}mm
                        </option>
                      </select>
                    </div>
                    <div class="w-1/4 mr-2">
                      <label>Wielkość fontu - Cena</label>
                      <select v-model="params.font_size_price"
                              class="flex-1 w-4/5 vs-inputx vs-input--input">
                        <option v-for="(item, key) in font_sizes" :value="item.value" class="w-4/5">
                          {{ item.text }}mm
                        </option>
                      </select>
                    </div>
                    <div class="w-1/4 mr-2">
                      <label>Wielkość fontu - Masa netto</label>
                      <select v-model="params.font_size_weight_netto"
                              class="flex-1 w-4/5 vs-inputx vs-input--input">
                        <option v-for="(item, key) in font_sizes" :value="item.value" class="w-4/5">
                          {{ item.text }}mm
                        </option>
                      </select>
                    </div>
                    <div class="w-1/4">
                      <label>Wielkość fontu - Główny</label>
                      <select v-model="params.font_size_additional"
                              class="flex-1 w-4/5 vs-inputx vs-input--input">
                        <option v-for="(item, key) in font_sizes" :value="item.value" class="w-4/5">
                          {{ item.text }}mm
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <vs-divider></vs-divider>
                <div class="vx-row px-2 mt-4">
                    <div class="flex w-full">
                        <div class="w-1/3 mr-4">
                            <vs-input class="w-full mt-4" label="Szerokość (mm)" v-model="params.width"
                                      v-validate="'required|alpha_num'" name="width"/>
                        </div>
                        <div class="w-1/3">
                            <vs-input class="w-full mt-4" label="Wysokość (mm)" v-model="params.height"
                                      v-validate="'required|alpha_num'" name="height"/>
                        </div>
                    </div>
                </div>
                <div class="vx-row px-2 mt-4">
                  <div class="flex w-full">
                    <div class="w-1/3 mr-4">
                      <vs-input class="w-full mt-4" label="Margines górny (mm)" v-model="params.margint"
                                v-validate="'required|alpha_num'" name="margint"/>
                    </div>
                    <div class="w-1/3">
                      <vs-input class="w-full mt-4" label="Margines dolny (mm)" v-model="params.marginb"
                                v-validate="'required|alpha_num'" name="marginb"/>
                    </div>
                  </div>
                </div>
                <vs-divider></vs-divider>
                <vs-button target :href="pdf_url" @click="popupActive = false">Pobierz PDF</vs-button>
            </div>
        </vs-popup>


        <vs-input class="w-1/2 mb-4" label-placeholder="Nazwa składnika"
                  v-model="search" placeholder="Wyszukaj produkt"/>


        <vs-table :data="products" stripe id="products-container">

            <template slot="thead">
                <vs-th>lp.</vs-th>
                <vs-th>Nazwa produktu</vs-th>
                <vs-th>Kalorie</vs-th>
                <vs-th>Białko</vs-th>
                <vs-th>Węglowodany</vs-th>
                <vs-th>Tłuszcz</vs-th>
                <vs-th class="text-center">Etykieta</vs-th>
                <vs-th class="text-center">Receptura</vs-th>
                <vs-th>&nbsp;</vs-th>
                <vs-th>&nbsp;</vs-th>
                <vs-th>&nbsp;</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].id">
                        {{ indextr + 1 }}
                    </vs-td>

                    <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                    </vs-td>

                    <vs-td :data="data[indextr].calorific">
                        {{ data[indextr].calorific }}
                    </vs-td>

                    <vs-td :data="data[indextr].protein">
                        {{ data[indextr].protein }}
                    </vs-td>

                    <vs-td :data="data[indextr].carbohydrates">
                        {{ data[indextr].carbohydrates }}
                    </vs-td>

                    <vs-td :data="data[indextr].fat">
                        {{ data[indextr].fat }}
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="text-center">
                        <div class="fonticon-wrap">
                            <a href="#" @click="popup(data[indextr].id)">
                                <i class="feather icon-file-text link"></i>
                            </a>
                        </div>
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="text-center">
                        <div class="fonticon-wrap">
                            <a :href="popupTechnical(data[indextr].id)" target="_blank">
                                <i class="feather icon-file-text"></i>
                            </a>
                        </div>
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="text-center">
                        <router-link :to="`/moje-produkty/edytuj/${data[indextr].id}`" class="link-settings">
                            <i class="feather icon-edit"></i>
                        </router-link>
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="text-center">
                        <div class="fonticon-wrap">
                            <a href="#" @click="duplicateOne(`${data[indextr].id}`)"
                               class="feather icon-copy"></a>
                        </div>
                    </vs-td>

                    <vs-td :data="data[indextr].id" class="text-center">
                        <div class="fonticon-wrap">
                            <a href="#" @click="deleteOne(`${data[indextr].id}`)"
                               class="feather icon-delete"></a>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>
        <vs-pagination class="mt-4" :total="productsCount" :max="10" v-model="productsPage"
                       goto></vs-pagination>
    </vx-card>
</template>


<script>
export default {
    data() {
        return {
            productsPage: 1,
            productsCount: 0,
            activeConfirm: false,
            currentPdfId: null,
            products: [],
            ingredients: [],
            popupActive: false,
            font_sizes: [
              {
                value: "1.2mm",
                text: '0.6'
              },
              {
                value: "1.5mm",
                text: '0.75'
              },
              {
                value: "1.8mm",
                text: '0.9'
              },
              {
                value: "2.4mm",
                text: '1.2'
              },
              {
                value: "2.8mm",
                text: '1.4'
              },
              {
                value: "3mm",
                text: '1.5'
              },
              {
                value: "3.2mm",
                text: '1.6'
              },
              {
                value: "3.6mm",
                text: '1.8'
              },
              {
                value: "5mm",
                text: '2.5'
              },
              {
                value: "4mm",
                text: '2.0'
              },
              {
                value: "6mm",
                text: '3.0'
              },
              {
                value: "7mm",
                text: '3.5'
              },
              {
                value: "8mm",
                text: '4.0'
              }
            ],
            params: {
                weight: 'weight:100',
                main: true,
                contains: true,
                keep: true,
                best_before: true,
                producer: true,
                gda: true,
                roughage: false,
                ean_8: false,
                ean_13: false,
                percent: false,
                price: false,
                products: true,
                recipe: false,
                logo: false,
                wni: false,
                width: 40,
                height: 60,
                margint: 0,
                marginb: 0,
                show_fiber_additional: false,
                one_line: false,
                font_size_name: '1.5mm',
                font_size_price: '1.2mm',
                font_size_weight_netto: '1.2mm',
                font_size_additional: '1.2mm',
            },
            productId: null,
            page: {
                buttons: [
                    {
                        name: 'Dodaj produkt',
                        url: '/moje-produkty/dodaj',
                        external: false
                    }, {
                        name: 'Eksportuj wszystkie',
                        url: process.env.VUE_APP_API_ENDPOINT + '/v1/export/csv/' + this.$store.state.AppActiveUser.id,
                        external: true
                    }
                ]
            },
            search: '',
            isLoading: false,
            awaitingSearch: false,
            timeout: null,
            toDeleteId: 0
        }
    },
    computed: {
        pdf_url() {
            let ps = this.productId + '?x=' + this.params.width + '&y=' + this.params.height + '&mt=' + this.params.margint + '&mb=' + this.params.marginb
            + '&show_fiber_additional=' + this.params.show_fiber_additional + '&font_size_name='
                + this.params.font_size_name + '&font_size_price=' + this.params.font_size_price + '&font_size_weight_netto=' + this.params.font_size_weight_netto
                + '&font_size_additional=' + this.params.font_size_additional;
            for (let i in this.params) {
                if(this.params[i] !== false && 'weight' === i) {
                  ps += '&p[]=' + this.params[i];
                }
                else if (this.params[i] === true) {
                  ps += '&p[]=' + i;
                }
            }

            return process.env.VUE_APP_API_ENDPOINT + '/v1/pdf/' + ps;
        }
    },
    mounted() {
        this.fetchData();
    },
    watch: {
        productsPage: function () {
            this.fetchData();
        },
        search: function (a, b) {
            if (!this.isLoading) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.productsPage = 1;
                    this.fetchProductsFiltered(a);
                    this.isLoading = true;
                }, 2000);
            }
        },
    },
    methods: {
        openLoadingInDiv() {
            this.$vs.loading({
                container: '#products-container',
                scale: 0.6
            });
        },
        closeLoadingInDiv() {
            this.$vs.loading.close('#products-container > .con-vs-loading')
        },
        fetchProductsFiltered() {
            this.openLoadingInDiv();
            this.$http.get(process.env.VUE_APP_API_ENDPOINT + '/v1/products?q=' + this.search + '&p=' + this.productsPage).then(response => {
                this.products = response.data.data.products;
                this.productsCount = Math.ceil(response.data.data.count / 10);
                this.isLoading = false;
                this.closeLoadingInDiv();
            });
        },
        popupTechnical(id) {
            return process.env.VUE_APP_API_ENDPOINT + '/v1/pdf/technical/' + id;
        },
        popup(id) {
            this.productId = id;
            this.popupActive = true;
        },
        deleteOne(id) {
            let self = this;
            self.toDeleteId = id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Potwierdź`,
                text: 'Czy na pewno skasować ten produkt?',
                accept: function () {
                    let url = process.env.VUE_APP_API_ENDPOINT + '/v1/products/' + self.toDeleteId;
                    this.$http.delete(url).then(response => {
                        if (response.data.data === true) {
                            this.$vs.notify({
                                color: 'success',
                                title: `Wiadomość`,
                                text: 'Produkt został usunięty',
                            })
                            self.fetchData();
                        }
                    });
                }
            })
        },
        duplicateOne(id) {
            let self = this;
            self.toDuplicateId = id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Potwierdź`,
                text: 'Czy na pewno wykonać duplikat produktu?',
                accept: function () {
                    let url = process.env.VUE_APP_API_ENDPOINT + '/v1/duplicate/' + self.toDuplicateId;
                    this.$http.put(url).then(response => {
                        if (response.data.data === true) {
                            this.$vs.notify({
                                color: 'success',
                                title: `Wiadomość`,
                                text: 'Produkt został skopiowany',
                            })
                            self.fetchData();
                        }
                    });
                }
            })
        },
        fetchData() {
            this.fetchProductsFiltered();
        },
        downloadLabel() {
            var x = $('#pdf-x').val();
            var y = $('#pdf-y').val();

            var str = '';
            $('#pdf-confirm-modal').find('input').each(function () {
                if ($(this).is(':checked')) {
                    str += '&p[]=' + $(this).val()
                }
            });

        }
    }
}

</script>

